import React, { Component, PropTypes } from 'react'
import Button from './Button'
import { Link } from 'react-router-dom'
import scrollToTop from '../scrollToTop'

const press = require('../data/press.json').slice(0, 3)

export class TriColumn extends Component {
  render() {
    return (
      <section className="section">
        <div className="container">
          <div className="section__head">
            <h2>Our Favorite PlayVS Stories</h2>
            <p>Check out what others have to say about us and get an inside look from the press.</p>
          </div>
          <div className="section__body">
            <div className="row">
              {press.map(article => {
                return (
                  <div className="column--third">
                    <div className={`card contained ${article.publisher}`}>
                      <div className="imageContainer">
                        <img src={article.logo} />
                      </div>
                      <div className="meta minHeight">
                        <div className="h7">{article.title}</div>
                        <p>{article.description}</p>
                      </div>
                      <a className="coverLink" href={article.link} />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="section__CTA">
            <Link className="buttonContainerLink" to="/press"  onClick={scrollToTop}>
              <Button type="button" className="btn btn__default" text="Read more" />
            </Link>
          </div>
        </div>
      </section>
    )
  }
}

export default TriColumn



// WEBPACK FOOTER //
// ./src/common/ui/components/triColumn__press--white.js